import React, { useEffect, useContext } from 'react';
import { MainContext } from '~/context';
import { LogoImage } from '~/shared/components/logoImage';
import {
  Container,
  ForgetPasswordBox,
  ImageContainer,
  TextTitle,
  SubText,
  InputContainer,
  Label,
  Input,
  ButtonSendEmail,
  Header,
  Backto,
} from './styles';

const ForgetPassword = () => {
  const context = useContext(MainContext);
  const { setLoginDisplay } = context;

  useEffect(() => {
    setLoginDisplay(true);
  }, []);

  return (
    <Container>
      <ForgetPasswordBox>
        <Header>
          <ImageContainer>
            <LogoImage />
          </ImageContainer>
        </Header>
        <TextTitle>Por favor, digite seu e-mail abaixo.</TextTitle>
        <SubText>Você receberá sua nova senha neste e-mail.</SubText>
        <InputContainer>
          <Label>E-mail</Label>
          <Input
            type="text"
            placeholder="Digite seu e-mail"
            onChange={(event) => {
              return event;
            }}
          />
        </InputContainer>
        <ButtonSendEmail type="button" onClick={() => {}}>
          GERAR NOVA SENHA
        </ButtonSendEmail>
        <Backto href="/receita/login">Voltar para o login</Backto>
      </ForgetPasswordBox>
    </Container>
  );
};

export default ForgetPassword;
